import React from 'react';
import { MoonStars, WaveSine, Pause, WifiSlash, Minus } from '@phosphor-icons/react';
import { MV, HATCH } from '../../lib/movementView';

export const VERDICT = {
  calm: { bg: MV.moving.bg, ring: '#A5D6A7', fg: MV.moving.text, Icon: MoonStars },
  restless: { bg: MV.quiet.bg, ring: '#F2C46B', fg: MV.quiet.text, Icon: WaveSine },
  still: { bg: MV.rest.bg, ring: '#A9BCAD', fg: MV.rest.text, Icon: Pause },
  silent: { bg: HATCH, ring: '#C4C8CE', fg: MV.sensor.text, Icon: WifiSlash },
  nodata: { bg: '#F7F5F1', ring: '#C9C1B5', fg: '#6B7280', Icon: Minus },
};
export const VERDICT_NAME = { calm: 'mvn_calm', restless: 'mvn_restless', still: 'mvn_still', silent: 'mvn_silent', nodata: 'mvn_nodata' };

export const durText = (t, min) => (min >= 60
  ? t('rep_dur_h_min', { h: Math.floor(min / 60), m: String(min % 60).padStart(2, '0') })
  : t('rep_dur_min', { m: min }));

// One plain sentence for a night from lastNights().
export function nightSentence(t, night, hm) {
  const s = night.summary;
  const ep = s.episodes || [];
  const dur = (m) => durText(t, m);
  switch (night.kind) {
    case 'nodata': return t('mvn_s_nodata');
    case 'silent': return t('mvn_s_silent');
    case 'still': return ep.length === 1
      ? t('mvn_s_still_moved', { at: hm(ep[0].from), dur: dur(s.longestStill?.minutes || 0) })
      : t('mvn_s_still', { dur: dur(s.longestStill?.minutes || 0) });
    case 'restless': return t('mvn_s_restless', { n: ep.length, first: hm(ep[0].from), last: hm(ep[ep.length - 1].to) });
    default:
      if (!ep.length) return t('mvn_s_calm_none', { from: hm(night.window.fromMs), to: hm(night.window.toMs) });
      if (ep.length === 1) return t('mvn_s_calm_once', { at: hm(ep[0].from) });
      return t('mvn_s_calm_many', { n: ep.length, first: hm(ep[0].from), last: hm(ep[ep.length - 1].to) });
  }
}

export function VerdictDot({ kind, size = 'md', active = false }) {
  const d = VERDICT[kind];
  const cls = size === 'sm' ? 'w-6 h-6' : 'w-8 h-8 sm:w-10 sm:h-10';
  return (
    <span className={`${cls} shrink-0 rounded-full grid place-items-center ${active ? 'ring-2 ring-offset-2 ring-ink/70' : ''}`}
      style={{ background: d.bg, boxShadow: `inset 0 0 0 1.5px ${d.ring}` }}>
      <d.Icon size={size === 'sm' ? 12 : 16} weight="fill" color={d.fg} />
    </span>
  );
}

export function VerdictChip({ kind, t, testid }) {
  const d = VERDICT[kind];
  return (
    <span className="inline-flex items-center gap-2 text-xs font-medium rounded-full pl-1 pr-3 py-1" style={{ background: kind === 'silent' ? '#F3F4F6' : d.bg, color: d.fg }} data-testid={testid} data-kind={kind}>
      <VerdictDot kind={kind} size="sm" />{t(VERDICT_NAME[kind])}
    </span>
  );
}
